function isRangeOverlap(x1, x2, y1, y2) {
  return Math.max(x1, y1) <= Math.min(x2, y2)
}

function snap(val, snapVal, rounding = Math.round) {
  return rounding(val / snapVal) * snapVal
}

const ApMath = {
  isRangeOverlap,
  snap,
}

export default ApMath
export {snap}
